import React from 'react';
import type { EntityListColumn } from 'c-pagination';
import type { Campaign } from 'c-sdk';
import CampaignThumbnail from '../CampaignThumbnail';

const CampaignListThumbnailCell: EntityListColumn<Campaign>['RenderCell'] = ({ entity }) => (
    <CampaignThumbnail campaign={entity} size={36} />
);

export default CampaignListThumbnailCell;
